<template>
  <el-form :ref="formName" :model="form" :rules="rules"
           v-loading="loading"
           element-loading-text="Logging you in..."
  >
    <el-alert v-if="error" title="Authentication failed" type="error" :description="error" show-icon></el-alert>
    <el-form-item label="Member Number" :inline-message="true" prop="username">
      <el-input v-model="form.username" placeholder="Member number" size="medium"/>
    </el-form-item>
    <el-form-item label="Password" :inline-message="true" prop="password">
      <el-input placeholder="Please input password" v-model="form.password" size="medium" show-password/>
    </el-form-item>
    <div class="form-action">
      <el-button type="primary" class="btn-submit" :disabled="loading" @click="submitForm()">Login
      </el-button>
      <el-button class="inline-link" type="text" @click="forgotPassword">Forgot my details</el-button>
    </div>
  </el-form>
</template>

<script>
import {mapState, mapActions} from 'vuex'
import {submitMixin} from "./_submitMixin"

export default {
  mixins: [submitMixin],
  data() {
    return {
      formName: 'loginForm',
      form: {
        username: '',
        password: ''
      },
      rules: {
        username: {
          required: true,
          message: "Member number is required",
          trigger: "blur"
        },
        password: {
          required: true,
          message: "Password is required",
          trigger: "blur"
        }
      }
    }
  },
  computed: {
    ...mapState({
      error: state => state.auth.error,
      loading: state => state.auth.loading
    }),
  },
  methods: {
    ...mapActions('auth', ['login', 'forgotPassword']),
    submitForm() {
      this.$refs[this.formName].validate(async (valid) => {
        if (!valid) {
          return false;
        }
        await this.login({...this.form})
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form {
  .el-alert {
    margin-bottom: 15px;
  }

  .el-form-item {
    margin-bottom: 10px !important;

    > > > .el-form-item__label {
      line-height: 22px;
      font-weight: bold;
    }

    > > > .el-form-item__content {
      .el-form-item__error {
        padding-top: 0;
        padding-bottom: 4px;
      }
    }
  }
}

.form-action {
  margin-top: 30px;

  .btn-submit {
    font-weight: bold;
    font-size: 16px;
    width: 100%;
    padding-top: 18px;
    padding-bottom: 18px;
  }

  .el-button--text {
    margin-left: 0;
    color: #67C23A;
    padding-top: 6px;
    padding-bottom: 0;

    &:hover {
      font-weight: bold;
    }
  }
}
</style>
